/**
 * Client-side deterrents only — production builds.
 * Browsers must receive HTML/JS/CSS to render the site, so source cannot be fully hidden.
 * Real secrets belong on the server (PHP API, env vars), never in frontend code.
 */
export function initSiteProtection(): void {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  document.body.classList.add("site-protected");

  document.addEventListener("contextmenu", (event) => {
    event.preventDefault();
  });

  document.addEventListener("keydown", (event) => {
    const key = event.key.toUpperCase();
    const ctrlOrMeta = event.ctrlKey || event.metaKey;

    if (key === "F12") {
      event.preventDefault();
      return;
    }

    if (event.ctrlKey && event.shiftKey && ["I", "J", "C", "K"].includes(key)) {
      event.preventDefault();
      return;
    }

    if (ctrlOrMeta && event.shiftKey && ["I", "J", "C"].includes(key)) {
      event.preventDefault();
      return;
    }

    if (ctrlOrMeta && ["U", "S", "P"].includes(key)) {
      event.preventDefault();
    }
  });

  document.addEventListener("dragstart", (event) => {
    const target = event.target as HTMLElement;
    if (target.tagName === "IMG") {
      event.preventDefault();
    }
  });
}
